import React, { useState } from "react";
import Button from "@components/Button";
import CustomInput, { CustomSelectInput } from "@components/CustomInput/CustomInput";
import { Home } from "@mui/icons-material";
import { useNavigate } from "react-router";
import styles from "./UpgradeAccessPage.module.css";
import { Input, MenuItem, Select } from "@mui/material";
import usePostPay from "@hooks/usePostPay";

const UpgradeAccessPage = () => {
    const navigate = useNavigate();
    const [doctorId, setDoctorId] = useState("");
    const [viewAccess, setViewAccess] = useState("");
    const [enableAction, setEnableAction] = useState("");
    const { handleUpgradeAccess } = usePostPay();

  const handleUpgrade = () => {
    const isViewable = viewAccess === "Yes";
    const isEnabled = enableAction === "Yes"; 
    if(handleUpgradeAccess({ doctorId: doctorId, isViewable: isViewable, isEnabled:isEnabled }))
      {
        setViewAccess("boolean select");
        setEnableAction("boolean select");
        setDoctorId("");
      }
  };

  const handleNavigateDashboard = () => {
    navigate("/");
  };

  const handleManagePostPayPage = () => {
    navigate("/managepostpay");
  };

  const viewAccessOptions = [
    { option: "Yes", value: "Yes" },
    { option: "No", value: "No" },
  ];

  return (
    <>
        <div className={styles.MenuWrapper}>
            <div className={styles.NavigationWrapper}>
                <Home className={styles.HomeIcon} onClick={handleNavigateDashboard} />{" "}
                <div>
                <span
                className={styles.DashboardText}
                onClick={handleNavigateDashboard}
                >
                    Dashboard
                </span>
                <span 
                className={styles.DashboardText}
                onClick={handleManagePostPayPage}
                >
                    /PostPay Panel
                </span>
                <span className={styles.RouteText}>/Upgrade Access</span>
                </div>
            </div>
            <div className={styles.ActionItemsWrapper}>
                <Button
                    className={styles.BtnClass}
                    text={"Back"}
                    btnType={"secondary"}
                    onClick={handleManagePostPayPage}
                />
                <Button
                    className={styles.BtnClass}
                    text={"Upgrade Access"}
                    btnType={"secondary"}
                />
            </div>
        </div>
        <div className={styles.FormWrapper}>
            <div className={styles.inputSection}>
                <label className={styles.label}>Doctor ID</label>
                <CustomInput
                className={styles.Input}
                value={doctorId}
                onChange={(e) => setDoctorId(e.target.value)}
                name="doctorID"
                />
            </div>
            
            <div className={styles.inputSection}>
                <label className={styles.label}>View Access</label>
                <CustomSelectInput
                className={styles.Input}
                selectOptions={viewAccessOptions}
                defaultOption="boolean select"
                value={viewAccess}
                onChange={(e) => setViewAccess(e.target.value)}
                name="viewAccess"
                />
            </div>
            <div className={styles.inputSection}>
                <label className={styles.label}>Enable Action</label>
                <CustomSelectInput
                className={styles.Input}
                selectOptions={viewAccessOptions}
                defaultOption="boolean select"
                value={enableAction}
                onChange={(e) => setEnableAction(e.target.value)}
                name="enableAction"
                />
            </div>

            <div className={styles.UpgradeButtonWrapper}>
                <Button text="Upgrade" btnType="primary" className={styles.BtnClass} onClick={handleUpgrade} />
            </div>
      </div>
    </>
  )
};

export default UpgradeAccessPage;
